module.exports = __webpack_public_path__ + "static/img/ico_dagou.3387e7ad.svg";